import React from "react";
import styles from "./searchInput.module.css";
import { FiSearch } from "react-icons/fi";

const SearchInput = (props) => {
  return (
    <div className={`${styles.search_input} ${props.className}`}>
      <svg
        className={styles.icon}
        viewBox="0 0 41 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.4141 26.8574C22.5917 26.8574 26.7891 22.6601 26.7891 17.4824C26.7891 12.3048 22.5917 8.10742 17.4141 8.10742C12.2364 8.10742 8.03906 12.3048 8.03906 17.4824C8.03906 22.6601 12.2364 26.8574 17.4141 26.8574Z"
          className={styles.iconPath}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.1641 17.4824C11.1641 15.8248 11.8225 14.2351 12.9946 13.063C14.1667 11.8909 15.7565 11.2324 17.4141 11.2324"
          className={styles.iconPath}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M27.4032 27.4523L27.3943 27.4612C26.7451 28.1104 26.7451 29.163 27.3943 29.8123L31.3364 33.7544C31.9857 34.4036 33.0383 34.4036 33.6876 33.7544L33.6964 33.7456C34.3456 33.0963 34.3456 32.0437 33.6964 31.3944L29.7543 27.4523C29.105 26.8031 28.0524 26.8031 27.4032 27.4523Z"
          className={styles.iconPath}
          stroke-width="2"
          stroke-linejoin="round"
        />
        <path
          d="M27.3883 27.4566L24.0508 24.1191"
          className={styles.iconPath}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <input
        style={props?.style}
        placeholder={props?.placeholder}
        onChange={props?.onChange}
        className={styles.input}
        value={props?.value}
      />
      {props?.rightIcon}
    </div>
  );
};

export default SearchInput;
